declare namespace $ {

	export class $bog_fragile_demo_retype_base1 extends $mol_view {
		limit( ): number
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=base1.view.tree.d.ts.map